<template>
  <div
    class="d-flex-row justify-start cart_applied_coupon b-radius-6 gap-6"
    v-if="type === 'pay-cart'"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.23191 13.1495C4.76039 12.6779 3.98827 12.672 3.51675 13.1436C3.29278 13.3675 2.92145 13.3734 2.69748 13.1495C0.434173 10.8862 0.434174 9.51874 2.69748 7.25544L5.79184 4.16108L6.72899 5.09823C6.95886 5.32809 7.32429 5.33988 7.56594 5.13359C7.58363 5.1277 7.60131 5.11001 7.6131 5.09823C7.85475 4.85657 7.85475 4.45578 7.6131 4.21412L6.67595 3.27697L7.71329 2.23962C8.82137 1.13155 10.2241 1.39088 11.9983 2.12764L12.346 2.27499C12.6407 2.40466 12.7822 2.74651 12.6525 3.04121C12.5169 3.34181 12.5169 3.68366 12.6525 3.99604C12.7763 4.30843 13.0179 4.55008 13.3244 4.67975C13.9669 4.94498 14.7036 4.64439 14.9806 4.00194C15.0337 3.85459 15.1516 3.73671 15.2989 3.68366C15.4404 3.62472 15.5995 3.63061 15.7527 3.68955L16.0769 3.8369C19.0888 5.09233 19.6192 6.38902 18.3697 9.40676L17.521 11.4461C17.3972 11.7467 17.0553 11.8881 16.7606 11.7585L12.6761 10.2437C12.9177 10.0021 12.9649 9.5659 12.7232 9.32424L10.1652 6.76623C9.92355 6.52458 9.52276 6.52458 9.28111 6.76623C9.26932 6.77802 9.25164 6.7957 9.24574 6.81339C9.03945 7.05504 9.05124 7.42047 9.28111 7.65034L11.8391 10.2083C12.069 10.4382 12.4344 10.45 12.6761 10.2437L15.128 12.6956L11.6328 16.1908C9.36952 18.4541 8.0021 18.4541 5.7388 16.1908L5.2378 15.6898C5.00794 15.4599 5.01383 15.0886 5.23781 14.8646C5.70933 14.3931 5.70933 13.6269 5.23191 13.1495Z"
        fill="#48E4FF"
      />
    </svg>

    <div class="d-flex-row space-between">
      <p class="t-white regular-m font-family-2 white-space-no">
        {{ couponDiscount }}
        {{ $t("cart.selected_coupon") }}
      </p>

      <button @click="clearCartCoupon">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4631 4.6665L11.3327 5.53607L5.53558 11.3332L4.66602 10.4636L10.4631 4.6665Z"
            fill="white"
          />
          <path
            d="M11.3327 10.4636L10.4631 11.3332L4.66602 5.53607L5.53558 4.6665L11.3327 10.4636Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
  <div
    class="d-flex-row space-between height-max-content md-row-to-col"
    v-if="type === 'cart' && totalDiscount !== '0%'"
    style="margin-bottom: 8px"
  >
    <div class="d-flex-row justify-start cart_applied_coupon b-radius-6 gap-6">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.23191 13.1495C4.76039 12.6779 3.98827 12.672 3.51675 13.1436C3.29278 13.3675 2.92145 13.3734 2.69748 13.1495C0.434173 10.8862 0.434174 9.51874 2.69748 7.25544L5.79184 4.16108L6.72899 5.09823C6.95886 5.32809 7.32429 5.33988 7.56594 5.13359C7.58363 5.1277 7.60131 5.11001 7.6131 5.09823C7.85475 4.85657 7.85475 4.45578 7.6131 4.21412L6.67595 3.27697L7.71329 2.23962C8.82137 1.13155 10.2241 1.39088 11.9983 2.12764L12.346 2.27499C12.6407 2.40466 12.7822 2.74651 12.6525 3.04121C12.5169 3.34181 12.5169 3.68366 12.6525 3.99604C12.7763 4.30843 13.0179 4.55008 13.3244 4.67975C13.9669 4.94498 14.7036 4.64439 14.9806 4.00194C15.0337 3.85459 15.1516 3.73671 15.2989 3.68366C15.4404 3.62472 15.5995 3.63061 15.7527 3.68955L16.0769 3.8369C19.0888 5.09233 19.6192 6.38902 18.3697 9.40676L17.521 11.4461C17.3972 11.7467 17.0553 11.8881 16.7606 11.7585L12.6761 10.2437C12.9177 10.0021 12.9649 9.5659 12.7232 9.32424L10.1652 6.76623C9.92355 6.52458 9.52276 6.52458 9.28111 6.76623C9.26932 6.77802 9.25164 6.7957 9.24574 6.81339C9.03945 7.05504 9.05124 7.42047 9.28111 7.65034L11.8391 10.2083C12.069 10.4382 12.4344 10.45 12.6761 10.2437L15.128 12.6956L11.6328 16.1908C9.36952 18.4541 8.0021 18.4541 5.7388 16.1908L5.2378 15.6898C5.00794 15.4599 5.01383 15.0886 5.23781 14.8646C5.70933 14.3931 5.70933 13.6269 5.23191 13.1495Z"
          fill="#48E4FF"
        />
      </svg>

      <div class="d-flex-row space-between">
        <p class="t-white regular-m font-family-2 white-space-no">
          {{ totalDiscount }}
          {{ $t("cart.selected_coupon") }}
        </p>
      </div>
    </div>

    <!-- <button
      @click="clearCartCoupon"
      class="remove_coupon_btn"
      v-if="coupon?.discount"
    >
      <p class="t-white regular-s font-family-2">{{ $t('remove_coupon') }}</p>
    </button> -->
  </div>
</template>

<script>
import TrashIcon from "~/components/icons/TrashIcon.vue";
import Tooltip from "~/components/custom/Tooltip.vue";
export default {
  data() {
    return {};
  },

  props: {
    coupon: {
      default: {},
    },
    type: {
      default: "cart",
    },
    refetch: {
      default: () => {},
    },
    invoiceCode: {
      default: "",
    },
    nonDiscountedPriceUsd: {
      default: 0,
    },
    nonDiscountedUsdPriceBase: {
      default: 0,
    },
    progressDiscount: {
      default: null,
    },
    couponPercent: {
      default: 0,
    },
  },
  computed: {
    couponDiscount() {
      let discountPercentage = 0;
      if (this.progressDiscount?.discount) {
        discountPercentage += parseInt(this.progressDiscount?.discount);
      }

      if (this.coupon?.discount) {
        if (this.coupon.usage_type === 1) {
          discountPercentage += this.coupon.discount;
        }
        if (this.coupon.usage_type === 2) {
          discountPercentage += parseInt(this.couponPercent);
        }
      }

      return `${discountPercentage}%`;
    },

    totalDiscount() {
      let discountPercentage = 0;
      const progressiveDiscounts = this.getGamePack.progress_discount || [];

      let array = progressiveDiscounts.filter(
        (discount) => discount.slab <= this.nonDiscountedUsdPriceBase
      );
      let discounter = array[array.length - 1];
      if (discounter?.slab) {
        discountPercentage += parseInt(discounter.discount);
      }

      if (this.coupon?.discount) {
        if (this.coupon.usage_type === 1) {
          discountPercentage += this.coupon.discount;
        }
        if (this.coupon.usage_type === 2) {
          let discount =
            (100 * this.coupon?.discount) / this.nonDiscountedPriceUsd;
          discountPercentage += Math.ceil(discount);
        }
      }

      return `${discountPercentage}%`;
    },
  },
  methods: {
    async clearCartCoupon() {
      if (this.type === "cart") {
        this.removeCoupon();
      } else if (this.type === "pay-cart") {
        await this.clearPayCartCoupon(this.invoiceCode);
        this.refetch();
      }
    },

    // async clearPayCartCoupon() {
    //   try {
    //     const clearCouponResponse = await axios.post(
    //       functions.getRouteLaravel("remove-coupon-from-order"),
    //       functions.paramsApi({
    //         invoice_code: this.invoiceCode,
    //       })
    //     );
    //     this.refetch();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },

  watch: {},

  setup() {
    const { getUserCurrencyCode } = useUserStore();
    const { getGamePack } = useGameStore();
    const { removeCoupon } = useCheckoutStore();
    const { getLocale } = useFunctions();
    const clearPayCartCoupon = async (invoiceCode) => {
      try {
        const { data } = await useApiPost("/api/remove-coupon-from-order", {
          method: "post",
          body: {
            locale: getLocale(),
            invoice_code: invoiceCode,
          },
        });
        return data;
      } catch (error) {
        console.log(error);
      }
    };

    return {
      getUserCurrencyCode,
      getGamePack,
      clearPayCartCoupon,
      removeCoupon,
    };
  },
  components: {
    TrashIcon,
    Tooltip,
  },
};
</script>
